module.exports = __webpack_public_path__ + "img/music-school-icon4.e8e06e3b.png";